/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
import { Component } from "react";
import PropTypes from "prop-types";
import { composeEventHandlers } from "./utils";

/**
 * @type {[]String}
 */
const SAFE_EVENT_HANDLERS = [
  "onUpArrow",
  "onDownArrow",
  "onEscape",
  "onDownArrow",
  "onRightArrow",
  "handleReturn",
  "onTab",
];

/**
 * @param   {[]String} eventKeys
 * @returns {Object}
 */
function generateSafeEventsPropTypes(eventKeys) {
  return eventKeys.reduce(
    (propTypes, eventKey) => ({
      ...propTypes,
      [eventKey]: PropTypes.func,
    }),
    {},
  );
}

let _handlersMap = new Map();

// if (process.env.NODE_ENV !== "production") {
//   module.hot.dispose(() => {
//     _handlersMap = new Map();
//   });
// }

export default class OnEditorEvent extends Component {
  static propTypes = generateSafeEventsPropTypes(SAFE_EVENT_HANDLERS);

  componentWillMount() {
    this.attachEventCallbacks(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.detachEventCallbacks(this.props);
    this.attachEventCallbacks(nextProps);
  }

  shouldComponentUpdate = () => false;

  componentWillUnmount() {
    this.detachEventCallbacks(this.props);
  }

  getEventKeys = (fromProps) =>
    Object.keys(fromProps).filter((maybeSafeEventKey) => SAFE_EVENT_HANDLERS.includes(maybeSafeEventKey));

  attachEventCallbacks = (eventsConfiguration) => {
    const eventsKeys = this.getEventKeys(eventsConfiguration);

    eventsKeys.forEach((eventKey) => {
      const eventCallback = eventsConfiguration[eventKey];
      this.wrapAndRegisterEventCallback(eventKey, eventCallback);
    });
  };

  detachEventCallbacks = (eventsConfiguration) => {
    const eventsKeys = this.getEventKeys(eventsConfiguration);

    eventsKeys.forEach((eventKey) => {
      const previouslySetEventCallbacks = _handlersMap.get(eventKey);

      previouslySetEventCallbacks.forEach((eventCallback) => {
        if (eventCallback === eventsConfiguration[eventKey]) {
          previouslySetEventCallbacks.delete(eventCallback);
        }
      });

      _handlersMap.set(eventKey, previouslySetEventCallbacks);
    });
  };

  /**
   * @param {String}   eventKey
   * @param {Function} eventCallback
   */
  wrapAndRegisterEventCallback = (eventKey, eventCallback) => {
    if (_handlersMap.has(eventKey)) {
      _handlersMap.set(eventKey, _handlersMap.get(eventKey).add(eventCallback));
      return;
    }

    _handlersMap.set(eventKey, new Set([eventCallback]));
  };

  render() {
    return null;
  }
}

/**
 * @param   {Set} callbackSet
 * @returns {[]Function}
 */
function iterateCallbackSet(callbackSet) {
  const eventCallbacks = [];

  for (const eventCallback of callbackSet) {
    eventCallbacks.push(eventCallback);
  }

  return eventCallbacks;
}

/**
 * @type {Function}
 */
const noop = () => {};

/**
 * @param   {?String} forKey
 * @returns {Object|[]Function}
 */
export function getRegisteredEvents(forKey) {
  if (forKey) {
    if (_handlersMap.has(forKey)) {
      const eventCallbacksForKey = _handlersMap.get(forKey);
      return composeEventHandlers(...iterateCallbackSet(eventCallbacksForKey));
    }

    return noop;
  }

  const registeredEvents = {};

  for (const eventKey of _handlersMap.keys()) {
    const eventCallbacksForKey = _handlersMap.get(eventKey);
    registeredEvents[eventKey] = composeEventHandlers(...iterateCallbackSet(eventCallbacksForKey));
  }

  return registeredEvents;
}

/**
 * @param   {String} forKey
 * @returns {Function}
 */
export function callRegisteredEvents(forKey) {
  return (keyboardEvent) => {
    const handleEventFn = getRegisteredEvents(forKey);
    return handleEventFn(keyboardEvent);
  };
}
